export default "__VITE_ASSET__3LGsZa9v__"